export const OkrVI = {
    "okr": "OKRs",
    "okrSetting":"ORKs",
    "periodOkrSetting": "Chu kỳ OKRs",
    "okrLabelSetting": "Nhãn",
    "periodCheckIn": "Chu kỳ check-in",
    "statusCheckIn": "Status check-in",
    "checkInQuestionGroup": "Nhóm câu hỏi checkin"
}